import { httpClient } from '../../../core/network';

export class DeviceService {
  static fetchDevices(customerId: string) {
    const apiUrl = `/customers/${customerId}/userdevices`;
    return httpClient.get(apiUrl);
  }

  static deleteDevices(userId: string, deviceIds: string[]) {
    const apiUrl = `/customers/userdevices/${userId}?${deviceIds
      .map(id => `device_id=${encodeURIComponent(id)}`)
      .join('&')}`;

    return httpClient.delete(apiUrl);
  }
}
